<div class="mb-5">
    <app-header></app-header>
</div>
<div class="d-flex align-items-center justify-content-between mb-4 mx-xl-3">
    <h6 class="montserrat-medium text-gray-500">Add your media</h6>
    <div>
        <button class="go-back small-action-btn bg-gray-500 text-white mr-3">
            <img
                src="./assets/images/icons/common/chevron-back.svg"
                alt="Go back"
                title="Go back"
            />
        </button>
        <button class="btn btn-lg btn-gray-500">proceed</button>
    </div>
</div>
<div class="d-xl-flex align-items-start justify-content-between">
    <app-highlights></app-highlights>
    <div class="flex-grow-1 mx-xl-3">
        <div class="bg-gray-200 p-3 br-15 mb-4">
            <div class="tableHolder table-responsive">
                <table mat-table [dataSource]="dataSource" class="table">
                    <!-- media -->
                    <ng-container matColumnDef="media">
                        <th mat-header-cell *matHeaderCellDef>Media</th>
                        <td mat-cell *matCellDef="let element">{{ element.media }}</td>
                    </ng-container>

                    <!-- image -->
                    <ng-container matColumnDef="image">
                        <th mat-header-cell *matHeaderCellDef>Image</th>
                        <td mat-cell *matCellDef="let element">
                            <img
                                [src]="getImgSrc(element.image)"
                                alt="media"
                                title="media"
                                width="100"
                                class="br-15"
                            />
                        </td>
                    </ng-container>

                    <!-- CH 1455 -->
                    <ng-container matColumnDef="CH-1455">
                        <th mat-header-cell *matHeaderCellDef>CH 1455</th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="element.ch1455; else noData">
                                <div class="text-center">
                                    <img
                                        src="./assets/images/icons/common/tick.svg"
                                        alt="tick"
                                        title="tick"
                                        width="15"
                                        class="mb-2"
                                    />
                                    <span class="d-block"> {{ element.ch1455 }}</span>
                                </div>
                            </ng-container>
                        </td>
                    </ng-container>

                    <!-- CH 1456 -->
                    <ng-container matColumnDef="CH-1456">
                        <th mat-header-cell *matHeaderCellDef>CH 1456</th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="element.ch1456; else noData">
                                <div class="text-center">
                                    <img
                                        src="./assets/images/icons/common/tick.svg"
                                        alt="tick"
                                        title="tick"
                                        width="15"
                                        class="mb-2"
                                    />
                                    <span class="d-block">{{ element.ch1456 }}</span>
                                </div>
                            </ng-container>
                        </td>
                    </ng-container>

                    <!-- CH 1686 -->
                    <ng-container matColumnDef="CH-1686">
                        <th mat-header-cell *matHeaderCellDef>CH 1686</th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="element.ch1686; else noData">
                                <div class="text-center">
                                    <img
                                        src="./assets/images/icons/common/tick.svg"
                                        alt="tick"
                                        title="tick"
                                        width="15"
                                        class="mb-2"
                                    />
                                    <span class="d-block"> {{ element.ch1686 }} </span>
                                </div>
                            </ng-container>
                        </td>
                    </ng-container>

                    <!-- CH 1755 -->
                    <ng-container matColumnDef="CH-1755">
                        <th mat-header-cell *matHeaderCellDef>CH 1755</th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="element.ch1755; else noData">
                                <div class="text-center">
                                    <img
                                        src="./assets/images/icons/common/tick.svg"
                                        alt="tick"
                                        title="tick"
                                        width="15"
                                        class="mb-2"
                                    />
                                    <span class="d-block">{{ element.ch1755 }}</span>
                                </div>
                            </ng-container>
                        </td></ng-container
                    >

                    <!-- CH 1559 -->
                    <ng-container matColumnDef="CH-1559">
                        <th mat-header-cell *matHeaderCellDef>CH 1559</th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="element.ch1559; else noData">
                                <div class="text-center">
                                    <img
                                        src="./assets/images/icons/common/tick.svg"
                                        alt="tick"
                                        title="tick"
                                        width="15"
                                        class="mb-2"
                                    />
                                    <span class="d-block">{{ element.ch1559 }}</span>
                                </div>
                            </ng-container>
                        </td>
                    </ng-container>

                    <!-- Edit -->
                    <ng-container matColumnDef="edit">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <a
                                href="javascript:;"
                                (click)="editMedia(element)"
                                class="edit-btn d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary m-auto"
                            >
                                <img
                                    src="./assets/images/icons/common/edit.svg"
                                    alt="Edit media"
                                    title="Edit media"
                                    width="20"
                                />
                            </a>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>
        </div>
    </div>
</div>
<ng-template #noData>
    <span class="text-gray">__</span>
</ng-template>
